import { render, staticRenderFns } from "./showInformationCustomerComponents.vue?vue&type=template&id=56c59677"
import script from "./showInformationCustomerComponents.vue?vue&type=script&lang=js"
export * from "./showInformationCustomerComponents.vue?vue&type=script&lang=js"
import style0 from "./showInformationCustomerComponents.vue?vue&type=style&index=0&id=56c59677&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports